import React from "react";
import * as styles from "./DropDownFilter.module.scss";
import { DropDown } from "@silversea-ssc/ui-components-react";

export interface DropDownFilterProps {
  label: string;
  expanded: boolean;
  children;
  count?: number;
  onExpandToggle: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  dataContentPiece?: string;
}

const DropDownFilter: React.FC<DropDownFilterProps> = ({
  label,
  children,
  expanded,
  count,
  dataContentPiece = null
}) => {
  const isExpanded = !!expanded;
  const expandedClass = isExpanded ? "ssc-dropdown-filter--expanded" : "";

  const dropDownLabel = (
    <React.Fragment>
      {label}{" "}
      <span className="ssc-dropdown-filter__counter">
        {count && count > 0 ? ` • ${count}` : ""}
      </span>
    </React.Fragment>
  );

  return (
    <div
      className={`ssc-dropdown-filter ${expandedClass}`}
      data-content-piece={dataContentPiece}
    >
      <DropDown
        label={dropDownLabel}
        expandOnMobile="open"
        expandOnTablet="absolute"
        expandOnDesktop="absolute"
        closeOnClickOutside={true}
        className={styles.dropdownFilter}
        buttonClassName={styles.dropdownButton}
        contentClassName={styles.dropdownContent}
      >
        {children}
      </DropDown>
    </div>
  );
};

export default DropDownFilter;
